import { render, staticRenderFns } from "./viewKcpGroups.vue?vue&type=template&id=96fefa72&scoped=true"
import script from "./viewKcpGroups.vue?vue&type=script&lang=js"
export * from "./viewKcpGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fefa72",
  null
  
)

export default component.exports